<template>
  <div id="contenedor-listado-actividades">
    <v-list>
      <template v-for="(actividad, index) in listadoActividades">
        <v-list-item :key="index">
          <v-list-item-content>
            <v-list-item-title>{{ actividad.descripcion }}</v-list-item-title>
            <v-list-item-subtitle>
              <v-chip :color="setColor(actividad)" text-color="white">
                Fecha de Plazo {{ new Date(actividad.fechaPlazo).toLocaleDateString() }}
              </v-chip>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Estatus: {{ actividad.estatus }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider
            v-if="index < listadoActividades.length - 1"
            :key="`${actividad.descripcion}-${index}`">
        </v-divider>
      </template>

    </v-list>
  </div>
</template>

<script>

export default {
  name: 'ListadoActividades',
  props: {
    listadoActividades: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
    };
  },
  methods: {
    setColor(actividad) {
      // Si la actividad ya esta completa no se asigna color
      if (actividad.completa) return 'grey darken-1';
      const plazo = this.getPlazo(actividad.fechaPlazo);
      if (plazo > 5) return '#43BC82';
      if (plazo <= 5 && plazo > 0) return '#FA8B00';
      return '#E53935';
    },
    getPlazo(fechaPlazo) {
      // Dia de hoy
      const fechaHoy = new Date();
      const a = this.$moment(fechaHoy);
      const b = this.$moment(fechaPlazo);
      // dias para llegar a fecha de plazo
      const plazo = (Number(b.diff(a, 'days')) + 1);
      if (plazo < 0) return 0;
      return plazo;
    },
  },
};
</script>

<style lang="scss">
</style>
